module.exports = __webpack_public_path__ + "static/img/icon-grzxS.3ed23eaf.png";